type Handler = () => void;
class Emitter {
  private m = new Map<string, Set<Handler>>();
  on(ev: string, h: Handler) {
    (this.m.get(ev) ?? this.m.set(ev, new Set()).get(ev)!).add(h);
    return () => {
      this.m.get(ev)?.delete(h);
    };
  }
  emit(ev: string) {
    this.m.get(ev)?.forEach((h) => h());
  }
}
export const authEvents = new Emitter();
